export default {
      id: "StatisticsRoutesAndAttractions-usage",
      viewBox: "0 0 43 42",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#StatisticsRoutesAndAttractions",
      toString: function () {
        return this.url;
      }
    }